<template>
  <div class="talent-list-section" :class="{ 'locale-zh-CN': isZhLocale }">
    <div class="talent-grid" :style="gridStyle">
      <div 
        v-for="talent in talentList" 
        :key="talent.id"
        class="talent-card"
        :class="cardClass"
        @click="handleTalentClick(talent)"
      >
        <div class="talent-avatar">
          <img :src="getAvatar(talent.avatar)" :alt="talent.name" class="avatar-img" @error="onImgError" />
        </div>
        <div class="talent-info">
          <div class="talent-name">{{ talent.name }}</div>
          
          <!-- 科技人才：显示职称 -->
          <div v-if="type === 'talent'" class="talent-title">{{ talent.title }}</div>
          
          <!-- 技术经理人：显示标签 -->
          <div v-if="type === 'manager'" class="manager-tags">
            <span 
              v-for="(tag, index) in talent.tags" 
              :key="'tag-' + index"
              class="tag-item"
            >
              {{ tag }}
            </span>
          </div>
          
          <!-- 科技人才：显示分隔线 -->
          <div v-if="type === 'talent'" class="talent-divider">
            <img src="~@/assets/img/kejirencai/item-line.png" alt="" class="divider-img" />
          </div>
          
          <!-- 科技人才：显示研究领域和地区 -->
          <template v-if="type === 'talent'">
            <div class="talent-research">{{ talent.research }}</div>
            <div class="talent-region">{{ talent.region }}</div>
          </template>
          
          <!-- 技术经理人：显示统计信息 -->
          <div v-if="type === 'manager'" class="manager-stats">
            <span class="stat-item">{{ viewsLabel }}{{ talent.views }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSafeImage, handleImgError } from '@/utils/imageFallback'
import { getText } from '@/utils/i18nText'
export default {
  name: 'TalentList',
  props: {
    // 人才列表数据
    talentList: {
      type: Array,
      required: true,
      default: () => []
    },
    // 类型：talent（科技人才）或 manager（技术经理人）
    type: {
      type: String,
      default: 'talent',
      validator: value => ['talent', 'manager'].includes(value)
    },
    // 列数：科技人才4列，技术经理人4列
    columns: {
      type: Number,
      default: 4
    }
  },
  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.columns}, 1fr)`
      }
    },
    
    cardClass() {
      return this.type === 'talent' ? 'talent-card-style' : 'manager-card-style'
    },
    viewsLabel() {
      return getText('talentList.viewsLabel', '浏览：')
    }
  },
  methods: {
    getAvatar(src) {
      return getSafeImage(src)
    },
    onImgError(event) {
      handleImgError(event)
    },
    handleTalentClick(talent) {
      this.$emit('talent-click', talent)
    }
  }
}
</script>

<style lang="scss" scoped>
.talent-list-section {
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  margin-bottom: 20px;
}

.talent-grid {
  display: grid;
  gap: 20px;
}

.talent-card {
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  height: 100%;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(160, 144, 60, 0.15);
    border-color: #A0903C;
  }
}

// 科技人才卡片样式
.talent-card-style {
  background-image: url('~@/assets/img/chuangxinyangling/item-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  gap: 15px;
  position: relative;
  overflow: hidden;
  
  // 装饰线条
  &::before {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 120px;
    background: linear-gradient(180deg, transparent 0%, #E8DCC0 50%, transparent 100%);
    opacity: 0.5;
  }
  
  .talent-avatar {
    flex-shrink: 0;
    margin-right: 15px;
    width: 120px;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .avatar-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 4px;
      object-fit: contain;
      object-position: center;
      border: 2px solid #F0F0F0;
    }
  }
  
  .talent-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
  }
}

// 技术经理人卡片样式
.manager-card-style {
  background-image: url('~@/assets/img/chuangxinyangling/item-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  gap: 15px;
  
  .talent-avatar {
    flex-shrink: 0;
    margin-right: 15px;
    width: 120px;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .avatar-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 4px;
      object-fit: contain;
      object-position: center;
      border: 2px solid #F0F0F0;
    }
  }
  
  .talent-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
  }
}

// 通用样式
.talent-name {
  font-family: Source Han Sans CN;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.talent-title {
  font-family: Source Han Sans CN;
  font-size: 12px;
  color: #A0903C;
  margin-bottom: 8px;
}

.talent-divider {
  margin-bottom: 8px;
  
  .divider-img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.talent-research {
  font-family: Source Han Sans CN;
  font-size: 11px;
  color: #666666;
  margin-bottom: 6px;
  margin-top: auto;
  line-height: 1.6;
}

.talent-region {
  font-family: Source Han Sans CN;
  font-size: 11px;
  color: #999999;
  line-height: 1.6;
}

// 技术经理人特有样式
.manager-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
  
  .tag-item {
    font-family: Source Han Sans CN;
    font-size: 11px;
    color: #A0903C;
    padding: 3px 8px;
    background: rgba(160, 144, 60, 0.1);
    border-radius: 3px;
    line-height: 1.4;
  }
}

.manager-stats {
  font-family: Source Han Sans CN;
  font-size: 12px;
  color: #999999;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  
  .stat-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  
  .stat-divider {
    color: #DDDDDD;
  }
  
  .star-rating {
    display: inline-flex;
    gap: 2px;
    
    .star {
      font-style: normal;
      color: #E8E8E8;
      font-size: 14px;
      
      &.active {
        color: #FFB800;
      }
    }
  }
}

.talent-list-section.locale-zh-CN {
  .talent-name {
    font-size: 20px;
  }

  .manager-card-style {
    .manager-tags .tag-item,
    .manager-stats {
      font-size: 15px;
    }
  }

  .talent-card-style {
    .talent-title {
      font-size: 16px;
    }

    .talent-research,
    .talent-region {
      font-size: 15px;
    }
  }
}
</style>
